import { render, staticRenderFns } from "./HomeAmilon.vue?vue&type=template&id=2a04238a&scoped=true"
import script from "./HomeAmilon.vue?vue&type=script&lang=js"
export * from "./HomeAmilon.vue?vue&type=script&lang=js"
import style0 from "./HomeAmilon.vue?vue&type=style&index=0&id=2a04238a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a04238a",
  null
  
)

export default component.exports